import { Instance, types } from "mobx-state-tree";

export const MediaTrackModel = types
  .model("MediaTrack", {
    enabled: false,
    trackId: types.maybe(types.string),
    // TODO: move track object to volatile state (if reasonable)
    track: types.maybe(types.frozen<MediaStreamTrack>())
  })
  .views((self) => {
    return {
      get isPlayable(): boolean {
        return self.enabled && !!self.trackId && !!self.track;
      }
    };
  })
  .actions((self) => {
    return {
      setMediaStreamTrack(track: MediaStreamTrack) {
        self.trackId = track.id;
        self.track = track;
        self.track.enabled = self.enabled;
      },
      enable() {
        self.enabled = true;
        if (self.trackId && self.track) {
          self.track.enabled = self.enabled;
        }
      },
      disable() {
        self.enabled = false;
        if (self.trackId && self.track) {
          self.track.enabled = self.enabled;
        }
      },
      stop() {
        self.enabled = false;
        if (self.trackId && self.track) {
          self.track.stop();
          self.trackId = undefined;
          self.track = undefined;
        }
      }
    };
  })
  .actions((self) => {
    return {
      toggle() {
        self.enabled ? self.disable() : self.enable();
      }
    };
  });

export enum PermissionStatus {
  GRANTED = "GRANTED",
  DENIED = "DENIED",
  UNKNOWN = "UNKNOWN"
}

/**
 * Device permission can be not granted and not denied at a time, it means user was not asked yet.
 */
const MediaTrackPermissionModel = types
  .model({
    permissionStatus: types.optional(
      types.enumeration("PermissionStatus", Object.values(PermissionStatus)),
      PermissionStatus.UNKNOWN
    )
  })
  .views((self) => {
    return {
      get isPermissionGranted(): boolean {
        return self.permissionStatus === PermissionStatus.GRANTED;
      },
      get isPermissionDenied(): boolean {
        return self.permissionStatus === PermissionStatus.DENIED;
      }
    };
  })
  .actions((self) => {
    return {
      grantPermission() {
        self.permissionStatus = PermissionStatus.GRANTED;
      },
      denyPermission() {
        self.permissionStatus = PermissionStatus.DENIED;
      }
    };
  });

export const LocalMediaTrackModel = types.compose(
  "LocalMediaTrack",
  MediaTrackModel,
  MediaTrackPermissionModel
);

export type IMediaTrackModel = Instance<typeof MediaTrackModel>;
export type ILocalMediaTrackModel = Instance<typeof LocalMediaTrackModel>;
